import { Grid } from '@material-ui/core'
import { Button, useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const DeleteVotesAndPutVPCToContre = ({ setIsChanged, ...props }) => {
  const classes = useStyles()
  const notify = useNotify()
  const { record } = props

  if (record.votes.length === 0) return null

  const deleteVotes = () => {
    Api.resolutions
      .delete(`${record.id}/votes_and_vpc`)
      .then((response) => {
        if (response.status === 200) {
          setIsChanged((prev) => {
            let newVal = new Date().getTime()
            return newVal
          })
          notify('Succès')
        } else {
          notify(
            `Une erreur est survenue veuillez réessayez plus tard.`,
            'warning'
          )
        }
      })
      .catch((error) => {
        notify(`${error.message}`, 'warning')
      })
  }

  return (
    <Grid item xs={12}>
      <Button
        variant="contained"
        color="secondary"
        className={classes.actionButton}
        size="normal"
        label="Supprimer les votes et passer les VPC à Contre"
        onClick={deleteVotes}
      />
    </Grid>
  )
}
export default DeleteVotesAndPutVPCToContre
